import React from "react";
import useSWR from "swr";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Onboarding from "@/pages/Onboarding";

const fetcher = (u) => api.get(u).then((r) => r.data);

/** Wrapper that resolves the current driver's ID from their email. */
const DriverOnboarding = () => {
  const { user } = useAuth();
  const { data: drivers = [] } = useSWR("/drivers?limit=500", fetcher);
  const me = drivers.find((d) => d.email && user?.email && d.email.toLowerCase() === user.email.toLowerCase());
  if (!me) return <div className="p-8 text-center text-slate-500 text-sm">Onboarding record not linked to your profile yet.</div>;
  return <Onboarding driverIdProp={me.id} editableTicks={false} />;
};

export default DriverOnboarding;
